// extracted by mini-css-extract-plugin
export var center = "_4t-2";
export var clickableRow = "_4t-5";
export var expandedRow = "_4t-7";
export var hoverable = "_4t-4";
export var left = "_4t-1";
export var right = "_4t-3";
export var row = "_4t-0";
export var selectedRow = "_4t-6";
export var summaryRow = "_4t-8";